<template>
  <div id="interactive-app">
    <v-app>
      <main-interactive></main-interactive>
    </v-app>
  </div>
</template>

<script>

import MainInteractive from './components/main-interactive/MainInteractive'

export default {
  name: 'App',
  data () {
    return {
      inAccecibilityMode: false,
      componentList: [],
      activeIndex: 0
    }
  },
  components: {
    MainInteractive
  },
  created: function () {
    window.addEventListener('keydown', e => {
      if (e.keyCode === 9) {
        if (this.inAccecibilityMode) {
          e.preventDefault()
        }
        if (e.shiftKey) {
          this.$eventHub.$emit('shift-tab-pressed')
        } else {
          this.$eventHub.$emit('tab-pressed')
        }
      }
    })
  }
}
</script>
<!-- Global CSS to be shared by all components -->
<style src="./main.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue